'use client';
var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/components/cosmic/background-renderer.tsx
import { AccentElements } from "./background-accents.js";
import { GeometricPatterns } from "./background-patterns.js";
import { TwinklingStars } from "./background-stars.js";
import { AnimatedWaves } from "./background-waves.js";
import { FloatingOrbs } from "./floating-orbs.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
function BackgroundElements({
  visibility,
  starCount,
  orbs,
  colorScheme,
  intensity
}) {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    visibility.shouldShowStars && /* @__PURE__ */ jsx(TwinklingStars, { count: starCount,
    intensity }),
    visibility.shouldShowOrbs && /* @__PURE__ */ jsx(FloatingOrbs, { orbs, intensity }),
    visibility.shouldShowPatterns && /* @__PURE__ */ jsx(GeometricPatterns, { colorScheme,
    intensity }),
    visibility.shouldShowWaves && /* @__PURE__ */ jsx(AnimatedWaves, { colorScheme,
    intensity }),
    visibility.shouldShowAccents && /* @__PURE__ */ jsx(AccentElements, { colorScheme,
    intensity })
  ] });
}
__name(BackgroundElements, "BackgroundElements");
export {
  BackgroundElements
};
